// extracted by mini-css-extract-plugin
module.exports = {"search-btns":"index_search-btns__3pwZU","expand-btn":"index_expand-btn__nTsch"};